import { Sparkles } from "lucide-react";

export default function ZuntriaLoader({ label = "Loading Zuntria…" }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4" data-testid="zuntria-loader">
      <div className="relative h-16 w-16">
        <div className="absolute inset-0 animate-spin rounded-full border-2 border-transparent" style={{ borderTopColor: "#00F5D4", borderRightColor: "#7B2FFF" }} />
        <div className="absolute inset-2 flex items-center justify-center rounded-xl bg-primary">
          <Sparkles className="h-5 w-5 text-primary-foreground" />
        </div>
      </div>
      <span className="font-display text-sm text-muted-foreground">{label}</span>
    </div>
  );
}
